@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources/"

@delegate:ResourceContentHash(147_368_539)
internal val Res.string.edit_day_fri: StringResource by lazy {
      StringResource("string:edit_day_fri", "edit_day_fri", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9117, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7365, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6417, 28),
      ))
    }

@delegate:ResourceContentHash(-2_124_475_921)
internal val Res.string.edit_day_mon: StringResource by lazy {
      StringResource("string:edit_day_mon", "edit_day_mon", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9150, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7398, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6446, 28),
      ))
    }

@delegate:ResourceContentHash(1_728_832_570)
internal val Res.string.edit_day_sat: StringResource by lazy {
      StringResource("string:edit_day_sat", "edit_day_sat", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9187, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7427, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6475, 32),
      ))
    }

@delegate:ResourceContentHash(-1_518_530_636)
internal val Res.string.edit_day_sun: StringResource by lazy {
      StringResource("string:edit_day_sun", "edit_day_sun", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9220, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7456, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6508, 28),
      ))
    }

@delegate:ResourceContentHash(-274_821_445)
internal val Res.string.edit_day_thu: StringResource by lazy {
      StringResource("string:edit_day_thu", "edit_day_thu", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9257, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7489, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6537, 32),
      ))
    }

@delegate:ResourceContentHash(-614_693_214)
internal val Res.string.edit_day_tue: StringResource by lazy {
      StringResource("string:edit_day_tue", "edit_day_tue", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9298, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7518, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6570, 32),
      ))
    }

@delegate:ResourceContentHash(1_606_954_781)
internal val Res.string.edit_day_wed: StringResource by lazy {
      StringResource("string:edit_day_wed", "edit_day_wed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9339, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7547, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6603, 32),
      ))
    }

@delegate:ResourceContentHash(358_382_606)
internal val Res.string.edit_description_label: StringResource by lazy {
      StringResource("string:edit_description_label", "edit_description_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9384, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7580, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6636, 46),
      ))
    }

@delegate:ResourceContentHash(-1_577_390_088)
internal val Res.string.edit_email_label: StringResource by lazy {
      StringResource("string:edit_email_label", "edit_email_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9435, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7627, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6683, 32),
      ))
    }

@delegate:ResourceContentHash(725_243_860)
internal val Res.string.edit_error: StringResource by lazy {
      StringResource("string:edit_error", "edit_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9476, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7664, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6716, 58),
      ))
    }

@delegate:ResourceContentHash(-1_339_939_568)
internal val Res.string.edit_hours_placeholder: StringResource by lazy {
      StringResource("string:edit_hours_placeholder", "edit_hours_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9559, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7731, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6775, 66),
      ))
    }

@delegate:ResourceContentHash(-1_414_296_455)
internal val Res.string.edit_identity_hint: StringResource by lazy {
      StringResource("string:edit_identity_hint", "edit_identity_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9642, 162),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7802, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6842, 110),
      ))
    }

@delegate:ResourceContentHash(891_042_751)
internal val Res.string.edit_lang_en: StringResource by lazy {
      StringResource("string:edit_lang_en", "edit_lang_en", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9805, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7937, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6953, 32),
      ))
    }

@delegate:ResourceContentHash(349_649_487)
internal val Res.string.edit_lang_fa: StringResource by lazy {
      StringResource("string:edit_lang_fa", "edit_lang_fa", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9846, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7970, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6986, 28),
      ))
    }

@delegate:ResourceContentHash(1_735_552_202)
internal val Res.string.edit_lang_fr: StringResource by lazy {
      StringResource("string:edit_lang_fr", "edit_lang_fr", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9883, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7999, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7015, 28),
      ))
    }

@delegate:ResourceContentHash(-1_053_004_424)
internal val Res.string.edit_language_hint: StringResource by lazy {
      StringResource("string:edit_language_hint", "edit_language_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9924, 262),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8032, 202),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7044, 166),
      ))
    }

@delegate:ResourceContentHash(-463_334_164)
internal val Res.string.edit_name_label: StringResource by lazy {
      StringResource("string:edit_name_label", "edit_name_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10187, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8235, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7211, 43),
      ))
    }

@delegate:ResourceContentHash(716_308_365)
internal val Res.string.edit_offers_chat: StringResource by lazy {
      StringResource("string:edit_offers_chat", "edit_offers_chat", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10243, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8287, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7255, 60),
      ))
    }

@delegate:ResourceContentHash(-1_257_500_568)
internal val Res.string.edit_offers_ordering: StringResource by lazy {
      StringResource("string:edit_offers_ordering", "edit_offers_ordering", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10356, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8356, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7316, 60),
      ))
    }

@delegate:ResourceContentHash(1_404_089_322)
internal val Res.string.edit_pending_address: StringResource by lazy {
      StringResource("string:edit_pending_address", "edit_pending_address", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10421, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8433, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7377, 48),
      ))
    }

@delegate:ResourceContentHash(-97_837_772)
internal val Res.string.edit_pending_category: StringResource by lazy {
      StringResource("string:edit_pending_category", "edit_pending_category", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10474, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8482, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7426, 49),
      ))
    }

@delegate:ResourceContentHash(776_039_365)
internal val Res.string.edit_pending_name: StringResource by lazy {
      StringResource("string:edit_pending_name", "edit_pending_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10540, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8536, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7476, 41),
      ))
    }

@delegate:ResourceContentHash(-1_362_439_330)
internal val Res.string.edit_pending_title: StringResource by lazy {
      StringResource("string:edit_pending_title", "edit_pending_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10582, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8578, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7518, 54),
      ))
    }

@delegate:ResourceContentHash(-1_448_645_359)
internal val Res.string.edit_phone_label: StringResource by lazy {
      StringResource("string:edit_phone_label", "edit_phone_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10649, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8641, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7573, 32),
      ))
    }

@delegate:ResourceContentHash(1_864_506_467)
internal val Res.string.edit_photo_failed: StringResource by lazy {
      StringResource("string:edit_photo_failed", "edit_photo_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10686, 141),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8682, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7606, 81),
      ))
    }

@delegate:ResourceContentHash(934_092_796)
internal val Res.string.edit_postal_label: StringResource by lazy {
      StringResource("string:edit_postal_label", "edit_postal_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10828, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8776, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7688, 41),
      ))
    }

@delegate:ResourceContentHash(-279_380_346)
internal val Res.string.edit_province_label: StringResource by lazy {
      StringResource("string:edit_province_label", "edit_province_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10874, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8818, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7730, 39),
      ))
    }

@delegate:ResourceContentHash(-976_278_875)
internal val Res.string.edit_remove_photo_a11y: StringResource by lazy {
      StringResource("string:edit_remove_photo_a11y", "edit_remove_photo_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10918, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8858, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7770, 46),
      ))
    }

@delegate:ResourceContentHash(80_519_617)
internal val Res.string.edit_request_button: StringResource by lazy {
      StringResource("string:edit_request_button", "edit_request_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10969, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8913, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7817, 51),
      ))
    }

@delegate:ResourceContentHash(1_567_951_314)
internal val Res.string.edit_request_failed: StringResource by lazy {
      StringResource("string:edit_request_failed", "edit_request_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11037, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8973, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7869, 63),
      ))
    }

@delegate:ResourceContentHash(-1_194_263_430)
internal val Res.string.edit_request_sent: StringResource by lazy {
      StringResource("string:edit_request_sent", "edit_request_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11137, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9045, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7933, 77),
      ))
    }

@delegate:ResourceContentHash(1_020_354_813)
internal val Res.string.edit_save: StringResource by lazy {
      StringResource("string:edit_save", "edit_save", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11451, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9291, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8135, 33),
      ))
    }

@delegate:ResourceContentHash(1_625_531_219)
internal val Res.string.edit_save_failed: StringResource by lazy {
      StringResource("string:edit_save_failed", "edit_save_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11259, 148),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9135, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8011, 96),
      ))
    }

@delegate:ResourceContentHash(869_831_893)
internal val Res.string.edit_saved: StringResource by lazy {
      StringResource("string:edit_saved", "edit_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11408, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9256, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8108, 26),
      ))
    }

@delegate:ResourceContentHash(1_234_592_299)
internal val Res.string.edit_section_about: StringResource by lazy {
      StringResource("string:edit_section_about", "edit_section_about", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11505, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9325, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8169, 34),
      ))
    }

@delegate:ResourceContentHash(1_394_131_825)
internal val Res.string.edit_section_contact: StringResource by lazy {
      StringResource("string:edit_section_contact", "edit_section_contact", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11548, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9364, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8204, 40),
      ))
    }

@delegate:ResourceContentHash(954_546_446)
internal val Res.string.edit_section_hours: StringResource by lazy {
      StringResource("string:edit_section_hours", "edit_section_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11609, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9409, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8245, 46),
      ))
    }

@delegate:ResourceContentHash(1_377_433_493)
internal val Res.string.edit_section_identity: StringResource by lazy {
      StringResource("string:edit_section_identity", "edit_section_identity", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11664, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9464, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8292, 65),
      ))
    }

@delegate:ResourceContentHash(-841_354_038)
internal val Res.string.edit_section_languages: StringResource by lazy {
      StringResource("string:edit_section_languages", "edit_section_languages", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11750, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9530, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8358, 54),
      ))
    }

@delegate:ResourceContentHash(923_613_815)
internal val Res.string.edit_section_photos: StringResource by lazy {
      StringResource("string:edit_section_photos", "edit_section_photos", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11833, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9585, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8413, 35),
      ))
    }

@delegate:ResourceContentHash(-1_536_382_527)
internal val Res.string.edit_section_price: StringResource by lazy {
      StringResource("string:edit_section_price", "edit_section_price", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11881, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9621, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8449, 42),
      ))
    }

@delegate:ResourceContentHash(-967_234_340)
internal val Res.string.edit_service_title_label: StringResource by lazy {
      StringResource("string:edit_service_title_label", "edit_service_title_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11928, 104),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9668, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8492, 68),
      ))
    }

@delegate:ResourceContentHash(-745_285_406)
internal val Res.string.edit_title: StringResource by lazy {
      StringResource("string:edit_title", "edit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12033, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9741, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8561, 34),
      ))
    }

@delegate:ResourceContentHash(1_464_178_461)
internal val Res.string.edit_website_label: StringResource by lazy {
      StringResource("string:edit_website_label", "edit_website_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12080, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9784, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8596, 38),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.mr_back_a11y: StringResource by lazy {
      StringResource("string:mr_back_a11y", "mr_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12127, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9823, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8635, 28),
      ))
    }

@delegate:ResourceContentHash(1_148_443_058)
internal val Res.string.mr_empty_desc: StringResource by lazy {
      StringResource("string:mr_empty_desc", "mr_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12164, 193),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9852, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8664, 105),
      ))
    }

@delegate:ResourceContentHash(1_152_448_116)
internal val Res.string.mr_empty_title: StringResource by lazy {
      StringResource("string:mr_empty_title", "mr_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12358, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9982, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8770, 42),
      ))
    }

@delegate:ResourceContentHash(893_305_576)
internal val Res.string.mr_error: StringResource by lazy {
      StringResource("string:mr_error", "mr_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12425, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10041, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8813, 48),
      ))
    }

@delegate:ResourceContentHash(1_560_567_767)
internal val Res.string.mr_owner_reply_label: StringResource by lazy {
      StringResource("string:mr_owner_reply_label", "mr_owner_reply_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12502, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10102, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8862, 44),
      ))
    }

@delegate:ResourceContentHash(-1_269_275_344)
internal val Res.string.mr_reply_action: StringResource by lazy {
      StringResource("string:mr_reply_action", "mr_reply_action", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12551, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10151, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8907, 31),
      ))
    }

@delegate:ResourceContentHash(-866_415_726)
internal val Res.string.mr_reply_failed: StringResource by lazy {
      StringResource("string:mr_reply_failed", "mr_reply_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12587, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10187, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8939, 71),
      ))
    }

@delegate:ResourceContentHash(1_886_192_092)
internal val Res.string.mr_reply_placeholder: StringResource by lazy {
      StringResource("string:mr_reply_placeholder", "mr_reply_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12695, 148),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10283, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9011, 92),
      ))
    }

@delegate:ResourceContentHash(5_014_338)
internal val Res.string.mr_reply_send: StringResource by lazy {
      StringResource("string:mr_reply_send", "mr_reply_send", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12844, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10392, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9104, 37),
      ))
    }

@delegate:ResourceContentHash(-574_583_101)
internal val Res.string.mr_retry: StringResource by lazy {
      StringResource("string:mr_retry", "mr_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12894, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10442, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9142, 28),
      ))
    }

@delegate:ResourceContentHash(-76_034_883)
internal val Res.string.mr_summary_desc: StringResource by lazy {
      StringResource("string:mr_summary_desc", "mr_summary_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 12927, 159),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10467, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9171, 103),
      ))
    }

@delegate:ResourceContentHash(1_930_350_731)
internal val Res.string.mr_summary_title: StringResource by lazy {
      StringResource("string:mr_summary_title", "mr_summary_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13087, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10579, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9275, 44),
      ))
    }

@delegate:ResourceContentHash(-1_842_427_983)
internal val Res.string.mr_title: StringResource by lazy {
      StringResource("string:mr_title", "mr_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 13144, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10628, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9320, 28),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("edit_day_fri", Res.string.edit_day_fri)
  map.put("edit_day_mon", Res.string.edit_day_mon)
  map.put("edit_day_sat", Res.string.edit_day_sat)
  map.put("edit_day_sun", Res.string.edit_day_sun)
  map.put("edit_day_thu", Res.string.edit_day_thu)
  map.put("edit_day_tue", Res.string.edit_day_tue)
  map.put("edit_day_wed", Res.string.edit_day_wed)
  map.put("edit_description_label", Res.string.edit_description_label)
  map.put("edit_email_label", Res.string.edit_email_label)
  map.put("edit_error", Res.string.edit_error)
  map.put("edit_hours_placeholder", Res.string.edit_hours_placeholder)
  map.put("edit_identity_hint", Res.string.edit_identity_hint)
  map.put("edit_lang_en", Res.string.edit_lang_en)
  map.put("edit_lang_fa", Res.string.edit_lang_fa)
  map.put("edit_lang_fr", Res.string.edit_lang_fr)
  map.put("edit_language_hint", Res.string.edit_language_hint)
  map.put("edit_name_label", Res.string.edit_name_label)
  map.put("edit_offers_chat", Res.string.edit_offers_chat)
  map.put("edit_offers_ordering", Res.string.edit_offers_ordering)
  map.put("edit_pending_address", Res.string.edit_pending_address)
  map.put("edit_pending_category", Res.string.edit_pending_category)
  map.put("edit_pending_name", Res.string.edit_pending_name)
  map.put("edit_pending_title", Res.string.edit_pending_title)
  map.put("edit_phone_label", Res.string.edit_phone_label)
  map.put("edit_photo_failed", Res.string.edit_photo_failed)
  map.put("edit_postal_label", Res.string.edit_postal_label)
  map.put("edit_province_label", Res.string.edit_province_label)
  map.put("edit_remove_photo_a11y", Res.string.edit_remove_photo_a11y)
  map.put("edit_request_button", Res.string.edit_request_button)
  map.put("edit_request_failed", Res.string.edit_request_failed)
  map.put("edit_request_sent", Res.string.edit_request_sent)
  map.put("edit_save", Res.string.edit_save)
  map.put("edit_save_failed", Res.string.edit_save_failed)
  map.put("edit_saved", Res.string.edit_saved)
  map.put("edit_section_about", Res.string.edit_section_about)
  map.put("edit_section_contact", Res.string.edit_section_contact)
  map.put("edit_section_hours", Res.string.edit_section_hours)
  map.put("edit_section_identity", Res.string.edit_section_identity)
  map.put("edit_section_languages", Res.string.edit_section_languages)
  map.put("edit_section_photos", Res.string.edit_section_photos)
  map.put("edit_section_price", Res.string.edit_section_price)
  map.put("edit_service_title_label", Res.string.edit_service_title_label)
  map.put("edit_title", Res.string.edit_title)
  map.put("edit_website_label", Res.string.edit_website_label)
  map.put("mr_back_a11y", Res.string.mr_back_a11y)
  map.put("mr_empty_desc", Res.string.mr_empty_desc)
  map.put("mr_empty_title", Res.string.mr_empty_title)
  map.put("mr_error", Res.string.mr_error)
  map.put("mr_owner_reply_label", Res.string.mr_owner_reply_label)
  map.put("mr_reply_action", Res.string.mr_reply_action)
  map.put("mr_reply_failed", Res.string.mr_reply_failed)
  map.put("mr_reply_placeholder", Res.string.mr_reply_placeholder)
  map.put("mr_reply_send", Res.string.mr_reply_send)
  map.put("mr_retry", Res.string.mr_retry)
  map.put("mr_summary_desc", Res.string.mr_summary_desc)
  map.put("mr_summary_title", Res.string.mr_summary_title)
  map.put("mr_title", Res.string.mr_title)
}
